<template>
  <div>
    <div class="inner item header">
      <img src="../assets/images/1.jpg" alt="" />
      <ul class="nav">
        <li
          @click="goNav(item.url)"
          :class="active == index ? 'active' : ''"
          v-for="(item, index) in headerList"
          :key="index"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      headerList: [
        {
          title: "首页",
          url: "/",
        },
        {
          title: "咨询师团队",
          url: "/team",
        }, 
        {
          title: "青少年心理健康",
          url: "/jiankang",
        },
        {
          title: "徐凯文专栏",
          url: "/xu",
        },
        {
          title: "大儒工作坊",
          url: "/job",
        },
      ],
    };
  },
  methods:{
    goNav(url){
      this.$router.push(url)
    }
  }
};
</script>

<style  scoped>
.nav {
  padding: 0;
  display: flex;
}
.nav li {
  margin-left: 30px;
  cursor: pointer;
}
.header {
  justify-content: space-between;
  height: 68px;
  align-items: center;
}
.header img {
  display: block;
  width: 250px;
  cursor: pointer;
}
.active {
  color: #3d94d9;
}
</style>